import { useTranslation } from 'react-i18next';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes } from '@similarweb/styles';

import { StyledCloseButton, StyledHeader, StyledHeaderTitle } from './styles';

type AIOutreachHeaderProps = {
  onClose: () => void;
};

export const AIOutreachHeader = ({ onClose }: AIOutreachHeaderProps) => {
  const { t } = useTranslation();

  return (
    <StyledHeader data-automation="AIOutreachHeader">
      <StyledHeaderTitle>
        <SWReactIcons iconName="craft-email" size="xs" iconColor={colorsPalettes.carbon[500]} />
        {t('company.overview.ai-outreach.title', 'AI Outreach')}
      </StyledHeaderTitle>
      <StyledCloseButton onClick={onClose} data-automation="AIOutreachClose">
        <SWReactIcons iconName="close" size="xs" iconColor={colorsPalettes.carbon[500]} />
      </StyledCloseButton>
    </StyledHeader>
  );
};
